import { Box, Flex, Heading, Image, Text,chakra } from '@chakra-ui/react';
import React from 'react';
import Profile from '../images/kalyan_profile.jpg';

export default function About() {
  return (
    <div id="about"  className="about section" >
        <Box  mx={"auto"} pt={5} px={{ base: 2, sm: 12, md: 17 }}>
        <chakra.h1
          textAlign={"center"}
          fontSize={"4xl"}
          py={10}
          fontWeight={"bold"}>
          About
        </chakra.h1>
      <Flex align="center" justify="space-evenly" flexWrap={{ base: 'wrap', md: 'nowrap' }}>
        <Box w={{ base: '100%', md: '50%' }} >
          <Image src={Profile} alt="" borderRadius="5%" w="50%" m="auto" p="20px" className="home-img" />
        </Box>
        <Box className="about-content" w={{ base: '100%', md: '50%' }}>
          <Heading as="h3" size="lg">
            I'm <span>Kalyan Kumar</span>
          </Heading>
          <Text id="user-detail-intro" fontSize="lg" m="20px" textAlign="left" color="gray.600" style={{ whiteSpace: "wrap", overflow: "hidden" }}>
  Full Stack Developer. With over 1200+ hours of practical coding experience in HTML, CSS, JavaScript, React.js, Redux, TypeScript, Node.js, Express, and MongoDB proficiency in working with interdisciplinary teams, and executing goal-oriented projects, they are well-suited for the role. Enhancing the product experience is their main objective, and they bring a strong work ethic and a positive attitude to every project they work on. Agile methodologies have been introduced to them, enabling them to develop excellent project management skills. A motivated, skilled, and team-oriented developer is what they are, making them an ideal candidate for any software development team looking for such a person.
</Text>

        </Box>
      </Flex>
    </Box>
    </div>
  );
}
